import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

// Example of user roles: ['GUEST', 'ADMIN', 'SUPERADMIN'];

function AuthGuard({ roles, children }) {
  const session = useSelector(state => state.session);
  const history = useHistory();

  useEffect(() => {
    if (!roles.includes(session.user.role)) {
      history.push('/errors/error-401');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roles, session.user]);

  return <>{children}</>;
}

AuthGuard.propTypes = {
  children: PropTypes.node,
  roles: PropTypes.array.isRequired
};

export default AuthGuard;
